import React, { FC, memo } from "react";
import { useTranslation } from "react-i18next";
import {
  BooksHeaderLink,
  BooksHeaderWrapper,
} from "../BooksHeader/BooksHeader.styles";

const RecipientsHeader: FC = () => {
  const { t } = useTranslation("common");
  return (
    <BooksHeaderWrapper>
      <BooksHeaderLink
        title={t("books.recipients")}
        end
        to="/books/recipients"
      >
        {t("books.recipients")}
      </BooksHeaderLink>
      <BooksHeaderLink
        title={t("books.passports.title")}
        end
        to="/books/passports"
      >
        {t("books.passports.title")}
      </BooksHeaderLink>
    </BooksHeaderWrapper>
  );
};

export default memo(RecipientsHeader);
